import React from "react";
import { Link, useNavigate } from "react-router-dom";
import useCart from "../context/useCart";

export default function Cart() {
  const {
    cart,
    updateQty,
    removeFromCart,
    increment,
    decrement,
    clearCart,
    itemCount,
    total,
    maxQty,
    formatXOF,
    openWhatsAppCart,
  } = useCart();

  const nav = useNavigate();

  const fmt = formatXOF ?? new Intl.NumberFormat("fr-FR", { style: "currency", currency: "XOF" });

  const onQtyChange = (id, val) => {
    const n = Math.floor(Number(val) || 0);
    if (n <= 0) {
      if (window.confirm("Supprimer cet article du panier ?")) {
        removeFromCart(id);
      }
      return;
    }
    updateQty(id, Math.min(maxQty || 99, n));
  };

  if (!cart || cart.length === 0) {
    return (
      <div className="container py-4">
        <h2 className="mb-3">Panier</h2>
        <p className="no-results">Votre panier est vide.</p>
        <Link to="/" className="btn btn-outline-primary">Retour aux vins</Link>
      </div>
    );
  }

  return (
    <div className="container py-4">
      <div className="d-flex align-items-center justify-content-between mb-3">
        <h2 className="m-0">Panier <span className="text-muted">({itemCount})</span></h2>
        <button
          className="btn btn-sm btn-outline-danger"
          onClick={() => {
            if (window.confirm("Vider le panier ?")) clearCart();
          }}
        >
          Vider le panier
        </button>
      </div>

      <div className="list-group mb-3">
        {cart.map((it) => {
          const unit = Number(it.price) || 0;
          const lineTotal = unit * (it.qty || 0);
          return (
            <div key={`${it.id}${it.variantKey ? `-${it.variantKey}` : ""}`} className="list-group-item">
              <div className="d-flex align-items-center">
                {it.imageUrl ? (
                  <img
                    src={it.imageUrl}
                    alt={it.name}
                    className="me-3"
                    style={{ width: 80, height: 80, objectFit: "cover", borderRadius: 8 }}
                    onError={(e) => (e.currentTarget.src = "/placeholder.png")}
                  />
                ) : (
                  <div className="me-3 bg-light border rounded" style={{ width: 80, height: 80 }} />
                )}

                <div className="flex-grow-1">
                  <div className="d-flex justify-content-between align-items-start">
                    <div>
                      <h5 className="mb-1">{it.name}</h5>
                      <small className="text-muted">
                        {it.region || "—"} {it.year ? `• ${it.year}` : ""} {it.variantKey ? `• ${it.variantKey}` : ""}
                      </small>
                    </div>
                    <div className="text-end">
                      <div className="text-nowrap">{fmt.format(unit)}</div>
                      <div className="small text-muted">Unitaire</div>
                    </div>
                  </div>

                  <div className="mt-2 d-flex flex-wrap align-items-center justify-content-between">
                    {/* Contrôles quantité */}
                    <div className="d-flex align-items-center gap-2">
                      <div className="input-group" style={{ width: 150 }}>
                        <button
                          type="button"
                          className="btn btn-outline-secondary"
                          onClick={() => decrement(it.id, 1, it.variantKey)}
                          aria-label="Diminuer la quantité"
                        >
                          −
                        </button>
                        <input
                          type="number"
                          className="form-control text-center"
                          min="1"
                          max={maxQty || 99}
                          value={it.qty || 1}
                          onChange={(e) => onQtyChange(it.id, e.target.value)}
                        />
                        <button
                          type="button"
                          className="btn btn-outline-secondary"
                          onClick={() => increment(it.id, 1, it.variantKey)}
                          aria-label="Augmenter la quantité"
                        >
                          +
                        </button>
                      </div>

                      <button
                        className="btn btn-sm btn-outline-danger"
                        onClick={() => {
                          if (window.confirm("Supprimer cet article ?")) removeFromCart(it.id, it.variantKey);
                        }}
                      >
                        Supprimer
                      </button>
                    </div>

                    {/* Total ligne */}
                    <div className="mt-2 mt-sm-0 text-end">
                      <div className="fw-semibold">{fmt.format(lineTotal)}</div>
                      <div className="small text-muted">Total ligne</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {/* Résumé */}
      <div className="d-flex flex-wrap gap-3 align-items-center justify-content-between">
        <div>
          <div className="text-muted">Sous-total ({itemCount} article{itemCount > 1 ? "s" : ""})</div>
          <div className="h4 m-0">{fmt.format(total)}</div>
        </div>
        <div className="d-flex flex-wrap gap-2">
          <button className="btn btn-secondary" onClick={() => nav(-1)}>
            Continuer mes achats
          </button>
          <Link to="/checkout" className="btn btn-primary">
            Passer à la commande
          </Link>
          <button
            className="btn btn-success"
            onClick={() => openWhatsAppCart?.("393895513136")}
            title="Envoyer le contenu du panier sur WhatsApp"
          >
            Commander sur WhatsApp
          </button>
        </div>
      </div>
    </div>
  );
}
